
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySphericalConeUp as ObiBuoySphericalConeUpElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spherical-cone-up.js';
 
 
 

 
 export const ObiBuoySphericalConeUp = createComponent({
   react: React,
   tagName: 'obi-buoy-spherical-cone-up',
   elementClass: ObiBuoySphericalConeUpElement,
   events: {
     
   }
  });
 
 